import { render, staticRenderFns } from "./ReadingAndSpeaking.vue?vue&type=template&id=74ee9edc&scoped=true&"
import script from "./ReadingAndSpeaking.vue?vue&type=script&lang=js&"
export * from "./ReadingAndSpeaking.vue?vue&type=script&lang=js&"
import style0 from "./ReadingAndSpeaking.vue?vue&type=style&index=0&id=74ee9edc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74ee9edc",
  null
  
)

export default component.exports